import styled from 'styled-components';

export const TextLineClamp = styled.div<{ $lines?: number }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: ${({ $lines }) => $lines ?? 2};
  -webkit-box-orient: vertical;
`;
